"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _reactRedux = require("react-redux");
var _paginationActions = require("../../../redux/actions/paginationActions");
var _SimplePaginationComponent = _interopRequireDefault(require("./SimplePaginationComponent"));
var _config = _interopRequireDefault(require("../../../config"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var mapDispatchToProps = function mapDispatchToProps(dispatch, ownProps) {
  return {
    setActivePage: function setActivePage(activePage) {
      return dispatch((0, _paginationActions.setActivePage)({
        componentName: ownProps.componentName,
        activePage: activePage
      }));
    }
  };
};
var mapStateToProps = function mapStateToProps(state, ownProps) {
  return {
    activePage: state.paginationMemory[ownProps.componentName],
    maxPages: _config["default"].Pagination.maxPages
  };
};
var _default = exports["default"] = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(_SimplePaginationComponent["default"]);